/**
 {
    name: 'Dashboard',
    icon: 'mdi-mdi-view-dashboard',
    to: 'dashboard',
    href: '#',
    children: [
      {
        name: 'Menu 1',
        to: 'dashboard',
        href: '#',
        fresh: true
      }
    ]
  }
*/

export default [
  {
    name: 'Dashboard',
    icon: 'mdi-view-dashboard-outline',
    to: 'dashboard'
  },
  {
    name: 'My workings',
    icon: 'mdi-briefcase-outline',
    to: 'my-workings'
  },
  {
    name: 'Projects',
    icon: 'mdi-projector-screen-outline',
    to: 'projects'
  },
  {
    name: 'Tickets',
    icon: 'mdi-timeline-help-outline',
    to: 'tickets'
  },
  {
    name: 'Task evaluation',
    icon: 'mdi-calendar-check-outline',
    to: 'task-evaluations.index'
  },
  {
    name: 'Project process',
    icon: 'mdi-page-next-outline',
    to: 'project-processes'
  },
  {
    name: 'My points',
    icon: 'mdi-star-four-points-outline',
    to: 'my-points.index'
  },
  {
    name: 'Feedback',
    icon: 'mdi-message-alert-outline',
    to: 'feedback',
    roles: ['employee']
  }
]
